import script from "./VanityGen.vue?vue&type=script&setup=true&lang=js"
export * from "./VanityGen.vue?vue&type=script&setup=true&lang=js"

import "./VanityGen.vue?vue&type=style&index=0&id=fae06240&lang=css"

const __exports__ = script;

export default __exports__